var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 57.5,
    r: 57.5,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2651 51.1524C67.3074 49.1101 68.4548 46.3402 68.4548 43.4519C68.4548 40.5637 67.3074 37.7937 65.2651 35.7514C63.2228 33.7091 60.4529 32.5618 57.5646 32.5618C54.6764 32.5618 51.9064 33.7091 49.8641 35.7514C47.8218 37.7937 46.6744 40.5637 46.6744 43.4519C46.6744 46.3402 47.8218 49.1101 49.8641 51.1524C51.9064 53.1947 54.6764 54.3421 57.5646 54.3421C60.4529 54.3421 63.2228 53.1947 65.2651 51.1524Z",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0887 68.0916C47.6628 64.5176 52.5102 62.5097 57.5646 62.5097C62.619 62.5097 67.4665 64.5176 71.0405 68.0916C74.6145 71.6656 76.6224 76.513 76.6224 81.5675H38.5068C38.5068 76.513 40.5147 71.6656 44.0887 68.0916Z",
    stroke: "#9CA3AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserDefault);
export default __webpack_public_path__ + "static/media/ic_user_default.ed7b2a26de21b1936ab7605cc328a61c.svg";
export { ForwardRef as ReactComponent };